import { message } from 'antd';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { history } from "../../../appRedux/store";
import { lockVisitAPI, unlockVisitAPI } from '../../../services/locked-visits-service';
import { getMrtParkedAPI, getVisitReportAPI, updateVisitReportStateAPI, fetchMrtPatientHistoryReportsAPI } from "../../../services/mrt-service";
// import { fetchVisitDictationsAPI } from '../../../services/patient-visits-service';
import { loadOrder } from '../../actions/integratorActions';
import {
    RESET_REVIEWING_REPORT,

    UNLOCK_VISIT,
    UNLOCK_VISIT_START,
    UNLOCK_VISIT_ERROR,

    VIEW_WORKLIST_VISIT,
    VIEW_WORKLIST_VISIT_ERROR,
    VIEW_WORKLIST_VISIT_SUCCESS,

    VIEW_PARKED_VISIT,
    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,
    VIEW_PARKED_VISIT_ERROR,

    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,

    UPDATE_VISIT_REPORT_STATE,
    UPDATE_VISIT_REPORT_STATE_START,
    UPDATE_VISIT_REPORT_STATE_SUCCESS,
    UPDATE_VISIT_REPORT_STATE_ERROR,

    VIEW_VERIFIED_VISIT,
    VIEW_VERIFIED_VISIT_START,
    VIEW_VERIFIED_VISIT_SUCCESS,
    VIEW_VERIFIED_VISIT_ERROR,

    FETCH_PATIENT_HISTORY_REPORTS,
    FETCH_PATIENT_HISTORY_REPORTS_START,
    FETCH_PATIENT_HISTORY_REPORTS_ERROR,
    FETCH_PATIENT_HISTORY_REPORTS_SUCCESS,
    UPDATE_STUDY,
    UPDATE_STUDY_SUCCESS,

} from "../../actions/mrt/reportViewerAction";
import { VIEW_WORKLIST_VISIT_LOADING_START, VIEW_WORKLIST_VISIT_LOADING_END, REMOVE_LOCKED_VISIT } from '../../actions/mrt/worklistAction';
import { TICKET_DETAILS_RESET } from '../../actions/ticketing/ticketActions';
import { IMAGE_VIEWERS, VISIT_STATES } from '../../../constants/constants';
import { setUnsavedChanges, SET_UNSAVED_CHANGES, SET_VISIT_LOCK } from '../../actions/activityAction';
import { VIEW_SFV_VISIT_LOADING_END, VIEW_SFV_VISIT_LOADING_START } from '../../actions/mrt/submittedForVerificationAction';
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START, VIEW_VERIFIED_VISIT_LOADING_END, VIEW_VERIFIED_VISIT_LOADING_START } from '../../actions';
import { VIEW_PARKED_VISIT_LOADING_END, VIEW_PARKED_VISIT_LOADING_START } from '../../actions/mrt/parkedAction';
import { updateStudyAPI } from '../../../services/group-admin-service';
import { generateTechnicianWorksheetAPI } from '../../../services/visits-report-service';
const initialSearch = {
    searchFilter: {
        searchText: "",
        sites: [],
        modalities: []
    },
    sortConditions: []
};

const getAuthUserState = (state) => state.auth.authUser;
const getIntegratorState = (state) => state.integrator;
const getRoutingLocation = (state) => state.routing.location;
const getParkedState = (state) => state.mrt.parked;
// const getRisUsersState = (state) => state.auth.authUser.risUserMips;

function* viewImages(payload) {
    try {
        const { imageViewer, orderLoaded } = yield select(getIntegratorState);
        switch (imageViewer) {
            case IMAGE_VIEWERS.INTELEVIEWER:
                yield put(loadOrder(payload));
                break;
            case IMAGE_VIEWERS.ORTHANC:
                // view images using orthanc
                break;
            default:
                break;
        }
    } catch (error) {
        console.log(error);
    }
}

// function* getRisUserNameForRisId(risId) {
//     try {
//         const risUsers = yield select(getRisUsersState);
//         if (risUsers.length > 0) {
//             const risUser = risUsers.find(user => user.risId === risId);
//             if (risUser) {
//                 return risUser.userName;
//             }
//             message.error("Ris user not found for ris id:" + risId);
//             return null;
//         }
//         message.error("Ris users not found!");
//         return null;
//     } catch (error) {
//         console.log(error);
//     }
// }



function* viewWorklistVisit({ report }) {

    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_WORKLIST_VISIT_LOADING_START })
        // const risUserName = yield getRisUserNameForRisId(report.risId);
        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);

        if (report.lockedBy == null) {
            const response = yield lockVisitAPI(report.reportId);
            if (response.success) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                // const visitDictationsResponse = yield fetchVisitDictationsAPI(report.visitNo)
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_WORKLIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport,
                            // dictations: visitDictationsResponse.success ? [visitDictationsResponse.data] : []
                            dictations: []
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId 
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mrt/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_WORKLIST_VISIT_ERROR })
                message.error('Visit is locked by other user!');
            }
            yield put({ type: VIEW_WORKLIST_VISIT_LOADING_END })
        } else {
            if (report.lockedBy === userId) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                // const visitDictationsResponse = yield fetchVisitDictationsAPI(report.visitNo)
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_WORKLIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport,
                            // dictations: visitDictationsResponse.success ? [visitDictationsResponse.data] : []
                            dictations: []
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mrt/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
                yield put({ type: VIEW_WORKLIST_VISIT_LOADING_END })
            } else {
                yield put({ type: VIEW_WORKLIST_VISIT_LOADING_END })
                yield put({ type: REMOVE_LOCKED_VISIT, report })
                message.error({ content: 'You are not allowed access this visit!', key: 'locked-visit-validation-2' });
            }
        }
    } catch (error) {
        yield put({ type: VIEW_WORKLIST_VISIT_LOADING_END })
        yield put({ type: VIEW_WORKLIST_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}

function* viewParkedVisit({ report }) {
    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_PARKED_VISIT_START })
        yield put({ type: VIEW_PARKED_VISIT_LOADING_START })
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        // const visitDictationsResponse = yield fetchVisitDictationsAPI(report.visitNo)
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_PARKED_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport,
                    // dictations: visitDictationsResponse.success ? [visitDictationsResponse.data] : []
                    dictations: []
                }
            })
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null,
                }
            })
            history.push({
                pathname: '/mrt/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            message.error('Failed to view parked visit!');
        }
        yield put({ type: VIEW_PARKED_VISIT_LOADING_END })
    } catch (error) {
        yield put({ type: VIEW_PARKED_VISIT_LOADING_END })
        yield put({ type: VIEW_PARKED_VISIT_ERROR, error })
        message.error('Failed to view parked visit!');
    }
}

function* viewSubmittedForVerificationVisit({ report }) {
    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_SFV_VISIT_LOADING_START })
        // const risUserName = yield getRisUserNameForRisId(report.risId);
        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);

        if (report.lockedBy == null) {
            const response = yield lockVisitAPI(report.reportId);
            if (response.success) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                // const visitDictationsResponse = yield fetchVisitDictationsAPI(report.visitNo)
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport,
                            // dictations: visitDictationsResponse.success ? [visitDictationsResponse.data] : []
                            dictations: []
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mrt/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR })
                message.error('Visit is locked by other user!');
            }
            yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        } else {
            if (report.lockedBy === userId) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                // const visitDictationsResponse = yield fetchVisitDictationsAPI(report.visitNo)
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport,
                            // dictations: visitDictationsResponse.success ? [visitDictationsResponse.data] : []
                            dictations: []
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mrt/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: REMOVE_LOCKED_VISIT, report })
                message.error({ content: 'You are not allowed access this visit!', key: 'locked-visit-validation-2' });
            }
            yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        }
    } catch (error) {
        yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error })
        message.error('Failed to update report status to draft!');
    }
}



function* viewVerifiedVisit({ visit }) {


    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({ type: VIEW_VERIFIED_VISIT_START })
        yield put({ type: VIEW_VERIFIED_VISIT_LOADING_START })
        // const response = yield call(getVisitReportAPI(report.risId, report.reportId, report.visitNo));
        const response = yield getVisitReportAPI(visit.risId, visit.reportId, visit.visitNo);

        if (response.success) {
            // const filteredPatientHistoryReports = response.patientHistoryReports.filter(report => report.reportId !== reportId && report.visit.visitNo !== visitNo);
            // yield put({ type: VIEW_VERIFIED_VISIT_SUCCESS, report: filteredPatientHistoryReports })
            yield put({
                type: VIEW_VERIFIED_VISIT_SUCCESS,
                report: {
                    ...response.visitReport
                }
            })
            history.push({
                pathname: '/mrt/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            yield put({ type: VIEW_VERIFIED_VISIT_ERROR })
            message.error('Failed to fetch verified reports!');
        }
        yield put({ type: VIEW_VERIFIED_VISIT_LOADING_END })
    } catch (error) {
        yield put({ type: VIEW_VERIFIED_VISIT_LOADING_END })
        yield put({ type: VIEW_VERIFIED_VISIT_ERROR, error })
        message.error('Failed to fetch verified reports!');
    }
}

function* updateVisitReportState({ payload }) {

    const { updateReportData, autoNextConfig } = payload;
    try {
        yield put({ type: UPDATE_VISIT_REPORT_STATE_START })
        const response = yield call(updateVisitReportStateAPI, updateReportData);

        if (response.success) {
            // Generate technician worksheet after the report text has been successfully saved
            // try {  
            //    // console.log("Generating technician worksheet for report ID:");
            //    // const worksheetResponse = yield call(generateTechnicianWorksheetAPI, response.visit.reportId);
            //     // if (worksheetResponse && worksheetResponse.success) {
            //     //     message.success("Technician worksheet generated successfully!");
            //     // } else if (worksheetResponse && worksheetResponse.error) {
            //     //     message.error("Failed to generate technician worksheet please try again by resubmitting the report for verification!");
            //     // }
            // } catch (e) {
            //     // Do not block the main flow if worksheet generation fails
            //     message.error("Failed to generate technician worksheet please try again by resubmitting the report for verification!");
            // }

            if (response.visit.state === VISIT_STATES.SFV) {
                yield put({ type: RESET_REVIEWING_REPORT })
                yield put(setUnsavedChanges(false));
                message.success(`Report Submitted successfully.`);
                if (autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, updateReportData);
                } else {
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: false,
                            reportId: null,
                        }
                    })
                    history.goBack();
                }
            } else {
                yield put(setUnsavedChanges(false))
                yield put({ type: UPDATE_VISIT_REPORT_STATE_SUCCESS, visit: { ...response.visit } })
                message.success(`Report parked successfully.`);
                if (autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, updateReportData);
                } else {
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: false,
                            reportId: null
                        }
                    })
                }
            }
        } else {
            const msg = updateReportData.state === VISIT_STATES.P ? "park" :
                updateReportData.state === VISIT_STATES.H ? "verify" : "park";
            if (response.error) {
                yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error: response.error })
                message.error(`Failed to ${msg} visit report!`);
            }
        }
    } catch (error) {

        yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error })
        message.error(`Failed to update report!`);
    }
}

function* viewNextVisit({ prevLocation }, currentVisit = null) {
    switch (prevLocation) {
        case '/mrt/parked':
            yield call(viewParkedNextVisit, currentVisit);
            break;
        default:
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.goBack();
            break;
    }
}

function* viewParkedNextVisit(currentVisit = null) {
    try {
        yield put({ type: RESET_REVIEWING_REPORT });
        yield put(setUnsavedChanges(false));
        yield put({ type: VIEW_PARKED_VISIT_START });
        const parkedState = yield select(getParkedState);
        let skippedVisits = parkedState.skippedVisits || [];
        if (currentVisit && currentVisit.reportId && !skippedVisits.includes(currentVisit.reportId)) {
            skippedVisits = [...skippedVisits, currentVisit.reportId];
        }
        const response = yield call(getMrtParkedAPI, {
            searchFilter: parkedState.searchFilter,
            sortConditions: parkedState.sortConditions,
            skippedVisits,
            page: parkedState.pagination.currentPage,
            size: parkedState.pagination.pageSize,
        });
        if (response.success) {
            const nextVisit = response.data && response.data.mrtParked && response.data.mrtParked.length ? response.data.mrtParked[0] : null;
            if (nextVisit) {
                const visitReportResponse = yield getVisitReportAPI(nextVisit.risId, nextVisit.reportId, nextVisit.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_PARKED_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport,
                            dictations: []
                        }
                    });
                    return;
                }
            }
            message.info("Next visit not found!");
            history.goBack();
        } else {
            yield put({ type: VIEW_PARKED_VISIT_ERROR, error: response.error })
            message.error(response.error || 'Failed to view next visit!');
            history.goBack();
        }
    } catch (error) {
        yield put({ type: VIEW_PARKED_VISIT_ERROR, error })
        message.error('Failed to view next visit!');
        history.goBack();
    }
}

function* unlockVisit({ payload }) {
    try {
        const { visit, onConfirm } = payload;
        yield put({ type: UNLOCK_VISIT_START })
        const response = yield call(unlockVisitAPI, visit.reportId);
        if (response.success) {
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            onConfirm();
        } else {
            onConfirm();
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to unlock visit!');
            }
        }
    } catch (error) {
        yield put({ type: UNLOCK_VISIT_ERROR, error })
        message.error('Failed to unlock visit!');
    }
}

function* fetchPatientHistoryReports({ visit }) {
    try {
        const { reportId: reportId, visitNo, patientId, } = visit;
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_START })
        const response = yield call(fetchMrtPatientHistoryReportsAPI, patientId);
        if (response.success) {
            const filteredPatientHistoryReports = response.patientHistoryReports.filter(report => report.reportId !== reportId && report.visit.visitNo !== visitNo);
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_SUCCESS, patientHistoryReports: filteredPatientHistoryReports })
        } else {
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR })
            message.error('Failed to fetch patient history reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR, error })
        message.error('Failed to fetch patient history reports!');
    }
}

function* updateStudy({ payload }) {
    try {
        const response = yield call(updateStudyAPI, payload);
        yield put({ type: SUBMIT_START })

        if (response.success) {
            message.success('Update study successfully.');

            yield put({ type: UPDATE_STUDY_SUCCESS, visit: payload })
            yield put({ type: HIDE_MODAL })

        } else {
            yield put({ type: SUBMIT_ERROR })
        }
    } catch (error) {
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to update study!');
    }
}

function* reportViewerWatcher() {
    yield takeLatest(VIEW_WORKLIST_VISIT, viewWorklistVisit)
    yield takeLatest(VIEW_PARKED_VISIT, viewParkedVisit)
    yield takeLatest(VIEW_SUBMITTED_FOR_VERIFICATION_VISIT, viewSubmittedForVerificationVisit)
    yield takeLatest(VIEW_VERIFIED_VISIT, viewVerifiedVisit)
    yield takeLatest(UPDATE_VISIT_REPORT_STATE, updateVisitReportState)
    yield takeLatest(UNLOCK_VISIT, unlockVisit)
    yield takeLatest(FETCH_PATIENT_HISTORY_REPORTS, fetchPatientHistoryReports)
    yield takeLatest(UPDATE_STUDY, updateStudy)
}


export default function* rootSaga() {
    yield all([
        reportViewerWatcher(),
    ]);
}
